import { File } from 'depoto-core/src/entities'

export const getThumbUrl = (image?: File, format: 'w135wp' | 'w2048wp' = 'w135wp'): string => {
  const url = image?.thumbnails?.find(t => t?.format === format)?.url
  if (url && image?.id) {
    return url
  }
  if (image?.url) {
    return image.url
  }
  return 'assets/img/image-not-found.png'
}
